import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import GlobalNotesTable from "@components/table/GlobalNotesTable";

const Notes: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Layout
      permissions={["ViewNotes"]}
      breadcrumb={[
        { label: t("dashboard.dashboard"), href: "/polestar" },
        { label: t("notes.global.title") },
      ]}
      title={t("notes.global.title")}
    >
      <GlobalNotesTable />
    </Layout>
  );
};

export default Notes;
